import React from 'react';
import StarRating from '../../tutor-details/components/StarRating';

const TutorCard = ({ data }) => {
  // const [isExpanded, setIsExpanded] = useState(false);

  // const handleReadMoreClick = () => {
  //   setIsExpanded((prevState) => !prevState);
  // };
  const offerings = [
    'Math',
    'Physics',
    'Science',
    'Trignometry',
    'Algebra',
    'Geometry',
    'Statistics',
    'Probability',
    'Integration',
    'Differenciation',
  ];

  return (
    <div className="relative mx-auto flex h-full flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-md md:max-w-[270px] ">
      {data?.profilePictureSrc ? (
        <img
          src={data?.profilePictureSrc}
          alt="Tutor"
          className="h-48 w-full rounded-xl object-cover p-[7px] md:mt-[7px] md:h-[158px] md:w-[254px] md:self-center md:p-0"
        />
      ) : (
        <div className="flex h-48 w-full items-center justify-center rounded-b-lg bg-[#B0D2D2]">
          <img src="/images/icons/no-profile.svg" alt="" className="h-[200px] w-[200px]" />
        </div>
      )}
      <div className="absolute right-4 top-4">
        <div className="flex items-center gap-1 rounded-full bg-[#16BDCA] p-1">
          <img src="/images/icons/SealCheck.svg" alt="" />
          <span className="text-[8px] font-medium leading-[150%] text-white">Verified Tutor</span>
        </div>
      </div>
      <div className="flex-grow p-3 pt-4">
        <div className="flex flex-wrap items-center justify-between">
          <div className="flex items-center gap-2">
            <h3 className="text-[20px] font-medium leading-normal tracking-[-0.4px] text-[#012E33]">
              {data?.name}
            </h3>
            <img src="/images/icons/messages.svg" alt="" />
          </div>
          <div>
            <span className="text-base font-medium tracking-[-0.32px] text-gray-500">$50-$100</span>
          </div>
        </div>
        <div className="mt-3 flex items-center justify-between">
          <p className="text-xs font-medium leading-[150%] text-gray-500">
            450 Hours <br />
            Tutored
          </p>
          <div className="flex flex-col gap-[5px]">
            <div>
              <StarRating width="12" height="12" className="justify-end !gap-0.5" rating={4.81} />
            </div>

            <p className="text-xs font-medium leading-[150%] text-gray-500">4.81 | 32 Ratings</p>
          </div>
        </div>
        <hr className="my-3" />

        <div className="flex flex-col gap-2">
          <p className="text-xs font-medium leading-[150%] text-gray-500">Offerings:</p>
          <div className="flex flex-wrap gap-1  ">
            {offerings.map((offering, index) => (
              <div
                key={index}
                className="flex items-center justify-center rounded-full border border-[#16BDCA] px-1.5 py-0.5"
              >
                <span className="text-xs leading-[150%] text-[#16BDCA]">{offering}</span>
              </div>
            ))}
          </div>
        </div>
        {/* <div className="mb-[14px] flex items-center gap-3">
          <div className="flex items-center gap-2">
            <img src="/images/icons/GraduationCap.svg" alt="graduationcap" className="h-6 w-6" />
            {data?.academicSubjects?.map((subject, index) => (
              <span
                key={index}
                className="font-[Fredoka] text-[16px] font-normal leading-normal tracking-[-0.32px] text-[#678285]"
              >
                {subject}
              </span>
            ))}
          </div>
        </div> */}

        {/* <p
          className={`fredoka mb-[19px] text-[16px] text-sm font-normal leading-[21px] tracking-[-0.32px] text-[#678285] ${
            isExpanded ? '' : 'line-clamp-2'
          }`}
        >
          {data?.bio}
        </p>
        <button
          onClick={handleReadMoreClick}
          className="fredoka mb-[22px] text-sm leading-[21px] text-[#678285] underline"
        >
          {isExpanded ? 'Read Less' : 'Read More'}
        </button> */}
      </div>
      {/* <div className="p-4 !pt-0">
        <Link
          to="/tutor-details"
          state={{ tutorDetails: data }}
          className="fredoka mb-2 block w-full rounded-2xl border border-[#FC823E] py-2 text-center font-semibold text-[#FC823E]"
        >
          Learn More
        </Link>

        <ShadowBtn
          className="w-full"
          text="Book Free Session"
          onClick={() => bookAppointment(data?.name)}
        />
      </div> */}
    </div>
  );
};

export default TutorCard;
